"use strict";
/**
 * Supplier linking types (GH547).
 *
 * Four pieces, each answering one question:
 *
 * | Piece | Question |
 * |---|---|
 * | `SupplierCommercialTerms` (on the supplier) | What does this supplier give us permanently? |
 * | `SupplierProduct` (`supplier_products`) | What does the supplier's code X cost today, and from which list? |
 * | `SupplierLink` (inside the catalog item) | Who sells us this article, and under which code? |
 * | `SupplierPromotion` (`supplier_promotions`) | What does the supplier give or discount, on what, until when? |
 *
 * The link never stores a price: prices live on the supplier product, so a list refresh never has
 * to touch our articles. Promotions point at the supplier's own codes; an article reaches them by
 * following its links, at read time.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPPLIER_LINK_QVET_PRICE_VALUES = void 0;
exports.SUPPLIER_LINK_QVET_PRICE_VALUES = ["skip", "force"];
